import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCrown"><Path d="M12.0018 2.19727L7.65945 8.71082L0.601562 5.18188L3.68868 20H20.315L23.4021 5.18188L16.3442 8.71082L12.0018 2.19727Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrown;
